import { GrnData, GrnItem, GrnBillings, GrnTax } from '../features/grn/types';

// Helper to handle parseFloat with both string and number types during gradual migration
const safeParseFloat = (value: any): number => parseFloat(value);

interface CalculateGrnTotalsResult {
  updatedProducts: GrnItem[];
  billings: GrnBillings & {
    totalGross: number;
    productdiscountAmount: number;
    discountAmount: number;
    taxableValue: number;
    vatAmount: number;
    netValue: number;
    finalInvoiceValue: number;
    billLevelDiscountApplied: boolean;
    billLevelTaxApplied: boolean;
    otherCharges: number;
  };
  taxes: GrnTax[];
}

export function calculateGrnTotals(grnData: GrnData, grnTaxTypes?: any[]): CalculateGrnTotalsResult {
  const products = grnData.products || [];
  const billings = grnData.billings || {};
  const grnDataAny = grnData as any; // For dynamic properties


  let grossAmount = 0;
  let totalDiscount = 0;
  let billdiscount = 0;
  let totalTax = 0;
  const taxCodeTotals: Record<string, { amount: number; taxrate: number; taxtype: string }> = {};// Sum of all chargerate values in grnData.charges


const otherCharges = Array.isArray(grnData?.addedCharges)
  ? grnData.addedCharges.reduce(
      (sum, addedCharges) => sum + (safeParseFloat(addedCharges.chaegerate || addedCharges.chargerate) || 0),
      0
    )
  : 0;


console.log("addedCharges array", grnData.addedCharges);
console.log("otherCharges", otherCharges);

    // Calculate total item value for all products
  const totalItemValue = products.reduce((sum, item) => {
    const receivedQty = safeParseFloat(item.receivedqty) || 0;
    const rejectedQty = safeParseFloat(item.rejectItem?.returnedqty) || 0;
    const unitPrice = safeParseFloat(item.unitprice) || 0;
    const acceptedQty = receivedQty - rejectedQty;
    return sum + (acceptedQty * unitPrice);
  }, 0); // Thusara

  

  // Get bill-level discount percent before map to use in calculations
  let billLevelDiscountPercent =
    safeParseFloat(billings.billLevelDiscountPercent) || 0;

  // Check if any product has item-level discount - if so, disable bill-level discount
  const hasItemLevelDiscount = products.some(
    (item) => safeParseFloat(item.discountrate) > 0
  );
  
  if (hasItemLevelDiscount === true) {
    billLevelDiscountPercent = 0;
  }

  const updatedProducts = products.map((item) => {
    const receivedQty = safeParseFloat(item.receivedqty) || 0;
    const rejectedQty = safeParseFloat(item.rejectItem?.returnedqty) || 0;
    const freeQty = safeParseFloat(item.freeqty) || 0;
    const unitPrice = safeParseFloat(item.unitprice) || 0;
    const poQty = safeParseFloat(item.poqty) || 0;
    const discountRate = safeParseFloat(item.discountrate) || 0;

    const acceptedQty = receivedQty - rejectedQty;
    const quantityDiff = poQty - acceptedQty;
    const effectiveQty = Math.max(acceptedQty - freeQty, 0);
    const totalQty = acceptedQty + freeQty;
    const billQty = Math.max(acceptedQty - freeQty, 0);
    const pendingPoQty = Math.max(poQty - acceptedQty, 0);

    const itemValue = acceptedQty * unitPrice;
    const discountAmount = (itemValue * discountRate) / 100;
    const grossAfterDiscount = itemValue - discountAmount;
    const taxRate = safeParseFloat(item.taxrate) || 0;
    const taxValue = (grossAfterDiscount * taxRate) / 100;

    const grossValue = itemValue  //grossAfterDiscount + taxValue; // Prasad


      const TotalQTY = acceptedQty + freeQty; // Thusara

    const UnitPriceafterFreeitems = itemValue / TotalQTY; // Thusara k

     const itemdistribution = totalItemValue > 0 ? itemValue / totalItemValue : 0; // Thusara

     // Calculate bill-level discount from billLevelDiscountPercent if item-level discount is 0
     // Otherwise use accumulated item-level discounts
     const DiscountBilllevel = discountRate === 0 && billLevelDiscountPercent > 0
       ? (itemValue * billLevelDiscountPercent) / 100
       : (totalDiscount || 0) * itemdistribution; // Thusara m
    
     const perunitdiscountvalue =DiscountBilllevel/ TotalQTY ;// Per unit Discount (Bill Level) n PerUnitDiscount_billlevel
  
     const Totalpriceafterdiscount_billlevel = itemValue - perunitdiscountvalue; // Thusara(Bill) Level o

     const perunittaxableamount = UnitPriceafterFreeitems - perunitdiscountvalue; // Thusara p

       const Taxableamount = itemValue - DiscountBilllevel; // Thusara q

       const Taxamount_itemlevel =  (taxRate * Taxableamount) / 100; // Thusara s

       const  perunittaxvalue = Taxamount_itemlevel / TotalQTY; // Thusara t perunittax_itemlevel

       const perunitaftertaxvalue = perunittaxableamount + perunittaxvalue; // Thusara u  perunitaftertax_itemlevel

      const othercharge_tot = otherCharges * itemdistribution; // Thusara 

      const othercharge_perunit = othercharge_tot / TotalQTY; // Thusara

      const unitcostwithouttax = perunittaxableamount + othercharge_perunit; // Thusara  13/10
      const unitcostwithtax = perunitaftertaxvalue + othercharge_perunit; // Thusara 14/10

      // Ensure unitcostwithouttax is defined for use in the final return
      grnDataAny.unitcostwithouttax = unitcostwithouttax;


    grossAmount += itemValue;
    totalDiscount += discountAmount;
    // Use finalTaxValue for totalTax calculation to account for bill-level discount
    const finalTaxForTotal = (discountRate === 0 && billLevelDiscountPercent > 0)
      ? Taxamount_itemlevel
      : taxValue;
    totalTax += finalTaxForTotal;

    const taxCode = String(item.taxcode || "unknown");
    if (!taxCodeTotals[taxCode]) {
      taxCodeTotals[taxCode] = {
        amount: 0,
        taxrate: item.taxrate || 0,
        taxtype: item.taxtype || "",
      };
    }
    // Use finalTaxValue for tax code totals to account for bill-level discount
    const finalTaxForCode = (discountRate === 0 && billLevelDiscountPercent > 0)
      ? Taxamount_itemlevel
      : taxValue;
    taxCodeTotals[taxCode].amount += finalTaxForCode;

    // Use Taxamount_itemlevel when bill-level discount is applied (discountrate is 0 but billLevelDiscountPercent > 0)
    // Otherwise use taxValue (based on item-level discount)
    const finalTaxValue = (discountRate === 0 && billLevelDiscountPercent > 0)
      ? Taxamount_itemlevel
      : taxValue;

    return {
      ...item,
      acceptedqty: acceptedQty,
      quantityDiff,
      billqty: billQty,
      totalqty: totalQty,
      pendingpoqty: pendingPoQty,
      itemvalue: parseFloat(itemValue.toFixed(2)),
      discountvalue: parseFloat(discountAmount.toFixed(2)),
      taxvalue: parseFloat(finalTaxValue.toFixed(2)),
      taxrate: safeParseFloat(item.taxrate || 0),
      grossvalue: parseFloat(grossValue.toFixed(2)),
      // new fields added Thusara
      taxableamount: parseFloat(Taxableamount.toFixed(2)), // Add taxableamount to return object
      perunittaxableamount: parseFloat(perunittaxableamount.toFixed(2)),
      perunitaftertaxvalue: parseFloat(perunitaftertaxvalue.toFixed(2)),
      perunittaxvalue: parseFloat(perunittaxvalue.toFixed(2)),
      perunitdiscountvalue: parseFloat(perunitdiscountvalue.toFixed(2)),
      unitpricewithfree: parseFloat(UnitPriceafterFreeitems.toFixed(2)),
      unitcostwithouttax : parseFloat(grnDataAny.unitcostwithouttax.toFixed(2)), // Thusara  
      unitdistribution: parseFloat(itemdistribution.toFixed(4)), // Thusara
      aftertaxvalue : parseFloat(grossAfterDiscount.toFixed(2)), // Thusara
     
      unitcostwithtax : parseFloat(unitcostwithtax.toFixed(2)), // Thusara
      othercharge_perunit : parseFloat(othercharge_perunit.toFixed(2)), // Thusara
      othercharge_tot : parseFloat(othercharge_tot.toFixed(2)), // Thusara
    };  
  });

  const hasItemLevelTax = updatedProducts.some(
    (item) => Number(item.taxvalue) > 0
  );

  const disableBillLevelDiscount = hasItemLevelDiscount;
  const disableBillLevelTax = hasItemLevelTax;



   

  const billLevelTaxPercent = safeParseFloat(billings.billLevelTaxPercent) || 0;
 // const otherCharges = safeParseFloat(billings.otherCharges) || 0;
  const penaltyCharges = safeParseFloat(billings.penaltyCharges) || 0;

  const discountAmount = totalDiscount + (grossAmount * billLevelDiscountPercent) / 100;
  //use below if billing discount is applied to after product discount - Prasad
  //const discountAmount = totalDiscount + ((grossAmount-totalDiscount) * billLevelDiscountPercent) / 100;

  const taxableValue = grossAmount - discountAmount;

  const vatAmount = disableBillLevelTax
    ? totalTax
    : (taxableValue * billLevelTaxPercent) / 100;

const netValue = taxableValue + vatAmount ;
const finalInvoiceValue = netValue + penaltyCharges + otherCharges;

  const taxes = Object.entries(taxCodeTotals).map(([code, data]) => ({
    taxcode: code,
    taxrate: data.taxrate,
    taxtype: data.taxtype,
    taxvalue: data.amount,
    amount: parseFloat(data.amount.toFixed(2)),
  }));

  //Please rename the variables and parameters - Prasad
  return {
    updatedProducts,
    billings: {
      ...billings,
      totalGross: parseFloat(grossAmount.toFixed(2)),
      productdiscountAmount: parseFloat(totalDiscount.toFixed(2)),
      discountAmount: parseFloat((discountAmount-totalDiscount).toFixed(2)),
      taxableValue: parseFloat(taxableValue.toFixed(2)),
      vatAmount: parseFloat(vatAmount.toFixed(2)),
      netValue: parseFloat(netValue.toFixed(2)),
      finalInvoiceValue: parseFloat(finalInvoiceValue.toFixed(2)),
      billLevelDiscountApplied: !disableBillLevelDiscount,
      billLevelTaxApplied: !disableBillLevelTax,
        otherCharges: parseFloat(otherCharges.toFixed(2)), // <-- add this line
        // unitcostwithouttax : parseFloat(unitcostwithouttax.toFixed(2)), // Thusara
        // unitcostwithtax : parseFloat(unitcostwithtax.toFixed(2)), // Thusara
    
    },
    taxes,
  };
}
